<template>
  <CDropdown 
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item d-md-down-none mx-2"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-bell"/>
        <CBadge shape="pill" color="danger">{{itemsCount}}</CBadge>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader 
      tag="div" 
      class="text-center bg-light"
    >
      <strong> Τελευταία Δραστηριότητα </strong>
    </CDropdownHeader>
   
    <CDropdownItem v-for="notif in notifs" :key="notif.id" v-on:click="redirectToElement(notif)">
      <CIcon name="cil-user-follow" class="text-success notificationIcon" v-if="notif.notification_type == 'clients'" />
      <CIcon :content="caseIcon" class="text-success notificationIcon" v-if="notif.notification_type == 'cases'" />
      {{ notif.notification_message }}
      <small style="width: 100%;text-align: end;">{{ getMoment(notif.created_at) }}</small>
    </CDropdownItem>

  </CDropdown>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { cilBriefcase } from '@coreui/icons'

export default {
  name: 'TheHeaderDropdownNotif',
  data () {
    return { 
      itemsCount: 0,
      notifs: [],
      caseIcon: cilBriefcase
    }
  },
  methods: {
    redirectToElement (item) {
      if (item.notification_type == "cases") {
        this.$router.push({path: `/cases/${item.notification_element_id}`});

        if (this.$router.history.current.name == "Case") {
          location.reload();
        }
      } else if (item.notification_type == "clients") {
        this.$router.push({path: `/clients/${item.notification_element_id}`});

        if (this.$router.history.current.name == "Client") {
          location.reload();
        }
      }
    },
    getMoment(date) {
      return moment(new Date(date)).fromNow();
    } 
  },
  mounted: function() {
    let self = this;

    axios.get('/api/notifications/?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.itemsCount = response.data.notifications.length;
      self.notifs = response.data.notifications;
    }).catch(function (error) {
      console.log(error);
      self.loading = false;
      self.$router.push({ path: '/login' });
    });
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>
